import { useSelector } from 'react-redux';

const useBaseSelector = () => useSelector((state: RootState) => state.feedback);

export const useIsShowCreateFeedbackRequestSelector = () => useBaseSelector().isShowCreateFeedbackRequest;
